<p-table #dv showGridlines [value]="assignments" [paginator]="showPaginator" [rows]="pageSize" [sortOrder]="sortOrder" [sortField]="sortField"
         [globalFilterFields]="['User.FirstName', 'User.LastName', 'User.Email', 'Crew.Name', 'Crew.Description']"
         [style]="{'width':'100%'}">
    <ng-template #caption>
        <div class="grid">
            <div class="col-sm-4">
                <input type="search" pInputText placeholder="{{'COMPONENTS.SearchAssignment' | translate}}" 
                       (input)="dv.filterGlobal($event.target.value, 'contains')" class="form-control">
            </div>
            <div class="col-sm-8">
                <div class="btn-container right" *ngIf="!isProjectCompleted">
                    <p-autoComplete [(ngModel)]="newUser" [suggestions]="userList" (completeMethod)="searchUsers($event)"
                                   (onSelect)="addUsers($event, dv)" [size]="50" placeholder="{{'COMPONENTS.SearchUsers' | translate}}" 
                                   optionLabel="Email" [minLength]="2" [dropdown]="true">
                        <ng-template let-u pTemplate="item">
                            <div class="ui-helper-clearfix">
                                <div><i class="pi pi-user"></i> {{u.FirstName}} {{u.LastName}} ({{u.Email}})</div>
                            </div>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #header>
        <tr>
            <th pSortableColumn="User.FirstName">{{'COMPONENTS.FullName' | translate}} <p-sortIcon field="User.FirstName"></p-sortIcon></th>
            <th pSortableColumn="User.Email">{{'COMPONENTS.Email' | translate}} <p-sortIcon field="User.Email"></p-sortIcon></th>
            <th pSortableColumn="Crew.Name">{{'COMPONENTS.Crew' | translate}} <p-sortIcon field="Crew.Name"></p-sortIcon></th>
            <th class="single-line-header">{{'COMPONENTS.ReadOnly' | translate}}</th>
            <th class="single-line-header">Actions</th>
        </tr>
    </ng-template>
    <ng-template #body let-assignment>
        <tr [ngClass]="{'tr-highlight': assignment.IsReadOnly}">
            <td>{{assignment.User.FirstName}} {{assignment.User.LastName}}</td>
            <td>{{assignment.User.Email}}</td>
            <td>
                <p-select *ngIf="assignment.backup" [(ngModel)]="assignment.Crew" [options]="crews" [group]="true" [style]="{'width':'100%'}" appendTo="body">
                    <ng-template let-it pTemplate="item">
                        <span class="list-sub-item">{{it.value.HierarchyPath}}</span>
                        <span *ngIf="it.value && it.value.Description">: {{it.value.Description}}</span>
                    </ng-template>
                    <ng-template let-it pTemplate="selectedItem">
                        <span>{{it.value.HierarchyPath}}</span>
                        <span *ngIf="it.value && it.value.Description">: {{it.value.Description}}</span>
                    </ng-template>
                </p-select>
                <div *ngIf="!assignment.backup">
                    <span>{{assignment.Crew.HierarchyPath}}</span>
                    <span *ngIf="assignment.Crew.Description">: {{assignment.Crew.Description}}</span>
                </div>
            </td>
            <td>
                <div class="single-line-cell">
                  <p-toggleswitch [(ngModel)]="assignment.IsReadOnly" (click)="updateUserViewOnlyAccess(assignment)"></p-toggleswitch>
                </div>
            </td>
            <td>
                <div class="btn-container right single-line-cell" *ngIf="!assignment.backup">
                    <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-info p-button-text" (click)="enterEditMode(assignment)"
                              [disabled]="isProjectCompleted"></p-button>
                    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-text" (click)="deleteAssignment(assignment, dv)"
                              [disabled]="isProjectCompleted"></p-button>
                </div>
                <div class="btn-container right single-line-cell" *ngIf="assignment.backup">
                    <p-button icon="pi pi-save" styleClass="p-button-rounded p-button-success p-button-text" (click)="saveAssignment(assignment)"
                              [disabled]="isProjectCompleted"></p-button>
                    <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-text" (click)="exitEditMode(assignment)"
                              [disabled]="isProjectCompleted"></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Add Multiple Crews" [(visible)]="visible" [modal]="true" [style]="{ width: '1000px', height: '500px' }" [draggable]="false" [resizable]="false">
    <p-toast></p-toast>
    <div class="dialog-content">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col">FullName</th>
                    <th scope="col">Email</th>
                    <th scope="col">Crew</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="col-md-2">{{fname}} {{lname}}</td>
                    <td class="col-md-2">{{uemail}}</td>
                    <td class="col-sm-6">
                        <p-multiSelect [options]="crews" [(ngModel)]="selectedCrew" defaultLabel="Select Crews" optionLabel="name" [group]="true" [style]="{'width':'100%'}">
                            <ng-template let-it pTemplate="selectedItems">
                                <div *ngFor="let option of it"  class="inline-flex align-items-center gap-2 px-1">
                                <div>{{option.value.HierarchyPath}} <span *ngIf="option.value && option.value.Description"></span>: {{option.value.Description}},</div>
                            </div>
                            <div></div>
                            </ng-template>
                            <ng-template let-it pTemplate="item">
                                <div>{{it.value.HierarchyPath}}</div>
                                <div *ngIf="it.value && it.value.Description">: {{it.value.Description}}</div>
                            </ng-template>
                        </p-multiSelect>
                    </td>
                    <td class="col-sm-1">
                        <p-button icon="pi pi-bookmark" label="Save" styleClass="p-button-raised" (click)="saveCrew(dv)"></p-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>

 <p-dialog header="Update Multiple Crews" [(visible)]="unassignDialogVisible" [modal]="true" [style]="{ width: '1000px', height: '500px' }" [draggable]="false" [resizable]="false">
    <p-toast></p-toast>
    <div class="dialog-content">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th scope="col">FullName</th>
                    <th scope="col">Email</th>
                    <th scope="col">Crew</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="col-md-2">{{Fullname}}</td>
                    <td class="col-md-2">{{uemail}}</td>
                    <td class="col-sm-6">
                        <p-multiSelect [options]="crews" [(ngModel)]="selectedCrewUser" defaultLabel="Select Crews" optionLabel="name" [group]="true" [style]="{'width':'100%'}" [panelStyle]="{'max-height': '300px'}">
                            <ng-template let-it pTemplate="selectedItems">
                                <div class="inline-flex align-items-center gap-2 px-1">
                                 <div>Select Crews</div>
                                </div> 
                            </ng-template> 
                            <ng-template let-it pTemplate="item">
                                <div>{{it.value.HierarchyPath}}</div>
                                <div *ngIf="it.value && it.value.Description">: {{it.value.Description}}</div>
                            </ng-template>
                        </p-multiSelect>
                    </td>
                    <td class="col-sm-1">
                        <p-button icon="pi pi-bookmark" label="Save" styleClass="p-button-raised" (click)="SaveUnassignCrew(dv)"></p-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>